export class Originator {
  userId: string = "";
  avatar: string = "";
  firstName: string = "";
  lastName: string = "";
  nmlsId: string = "";
  calendarLink: string = "";
}
